module.exports = __webpack_public_path__ + "static/media/sink-state-4.0d3d09b9.wav";